export const SET_ALL_USERS = 'SET_ALL_USERS';
export const REMOVE_USER = 'REMOVE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const CREATE_USER = 'CREATE_USER';

export const SET_USER_LOGS = 'SET_USER_LOGS';
export const SET_USER_MECHANIC_NEEDS = 'SET_USER_MECHANIC_NEEDS';
export const SET_USER_PLANS = 'SET_USER_PLANS';
